import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmazonInspectionComponent } from './amazon-inspection.component';
import { TabViewModule } from 'primeng';
import { RouterModule, Routes } from '@angular/router';
import { InspectionSiteSupplierComponent } from './inspection-site-supplier/inspection-site-supplier.component';
import { InspectionDeploymentComponent } from './inspection-deployment/inspection-deployment.component';

const routes: Routes = [
  {
    path: '',
    component: AmazonInspectionComponent,
    data: { title: 'Amazon Inspection' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AmazonInspectionRoutingModule {}

@NgModule({
  declarations: [AmazonInspectionComponent],
  imports: [
    CommonModule,
    TabViewModule,
    InspectionSiteSupplierComponent,
    AmazonInspectionRoutingModule,
    InspectionSiteSupplierComponent,
    InspectionDeploymentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AmazonInspectionModule {}
